import {
  put, takeLatest,
} from 'redux-saga/effects';
import { MapTool } from '~/_shared/types/toolsAndFeatures/mapTools.types';
import { demographicsListPremiumFetchDataRequest } from '~/store/demographics/premiumDemographics/demographicsListPremium.actionCreators';
import { mapToolChanged } from '~/store/frontendState/leftSidebar/leftSidebar.actionCreators';

export function* dataLayersSagas() {
  yield takeLatest(mapToolChanged, onMapToolChanged);
}

function* onMapToolChanged(action: ReturnType<typeof mapToolChanged>) {
  const openedTool = action.payload.newTool;

  if (openedTool === MapTool.DataLayers) {
    yield put(demographicsListPremiumFetchDataRequest());
  }
}
